<template>
  <v-card>
    <v-toolbar
      color="indigo"
      dark>

      <v-toolbar-title>
        <v-icon left>{{ chartIcon }}</v-icon>
        {{ $vuetify.lang.t('$vuetify.charts.criticalEventsDoughnut') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-skeleton-loader :loading="!loaded" type="card">
        <doughnut-chart :chart-data="localizedData"></doughnut-chart>
      </v-skeleton-loader>
    </v-card-text>
  </v-card>
</template>

<script>
import Vuetify from '../../plugins/vuetify'

import DoughnutChart from './DoughnutChart'
import backend from '../../backend'
import snackbarMixin from '../../mixins/snackbarMixin'
import { CriticalEventsDB } from '../../enum'
import { mdiChartDonut } from '@mdi/js'

const localization = () => ({
  [CriticalEventsDB.DISTRACTION]: '$vuetify.map.managerMap.headers.distraction',
  [CriticalEventsDB.DROWSINESS]: '$vuetify.map.managerMap.headers.drowsiness',
  [CriticalEventsDB.BELT_NOT_FASTEN]: '$vuetify.map.managerMap.headers.nobelt',
  [CriticalEventsDB.CAMERA_SABOTAGE]: '$vuetify.map.managerMap.headers.cameraSabotage',
  [CriticalEventsDB.CELLPHONE_USE]: '$vuetify.map.managerMap.headers.cellphoneUse',
  [CriticalEventsDB.EATING]: '$vuetify.map.managerMap.headers.eatingCount',
  [CriticalEventsDB.SMOKING]: '$vuetify.map.managerMap.headers.smokingCount',

})

export default {
  name: 'CriticalEventsDoughnut',
  mixins: [snackbarMixin],
  components: { DoughnutChart },
  props: {
    filters: Object
  },
  data: () => ({
    data: [],
    labels: [],
    loaded: false,
    chartIcon: mdiChartDonut
  }),
  computed: {
    localizedData () {
      const labels = this.labels.map(item => Vuetify.framework.lang.t(localization()[item]))
      return { labels, datasets: this.data.datasets }
    }
  },
  methods: {
    async loadData () {
      this.loaded = false
      try {
        const chartResponse = await backend.loadCriticalEventsChartDoughNut({ ...this.filters })
        this.data = chartResponse.data

        this.labels = chartResponse.data.labels
        this.data = chartResponse.data
      } catch (e) {
        this.processFailedRequest(e)
      } finally {
        this.loaded = true
      }
    }
  },
  async created () {
    await this.loadData()
  },
  watch: {
    async filters (value) {
      await this.loadData()
    }
  }
}
</script>

<style scoped>

</style>
